var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73307 16.5311C4.3607 16.5311 0.816406 12.9868 0.816406 8.61442C0.816406 4.24205 4.3607 0.697754 8.73307 0.697754C13.1054 0.697754 16.6497 4.24205 16.6497 8.61442C16.6497 12.9868 13.1054 16.5311 8.73307 16.5311ZM8.73307 14.9478C10.4128 14.9478 12.0237 14.2805 13.2114 13.0928C14.3991 11.905 15.0664 10.2941 15.0664 8.61442C15.0664 6.93472 14.3991 5.32381 13.2114 4.13608C12.0237 2.94835 10.4128 2.28109 8.73307 2.28109C7.05337 2.28109 5.44246 2.94835 4.25473 4.13608C3.067 5.32381 2.39974 6.93472 2.39974 8.61442C2.39974 10.2941 3.067 11.905 4.25473 13.0928C5.44246 14.2805 7.05337 14.9478 8.73307 14.9478ZM7.94378 11.7811L4.58474 8.42205L5.70416 7.30263L7.94378 9.54225L12.4214 5.0638L13.5417 6.18321L7.94378 11.7811Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkGreen);
export default __webpack_public_path__ + "static/media/markGreen.d6d9018d3e8f3a8bf93713a299e4a1b1.svg";
export { ForwardRef as ReactComponent };